import { render, staticRenderFns } from "./returntop.vue?vue&type=template&id=49735744&scoped=true"
import script from "./returntop.vue?vue&type=script&lang=js"
export * from "./returntop.vue?vue&type=script&lang=js"
import style0 from "./returntop.vue?vue&type=style&index=0&id=49735744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49735744",
  null
  
)

export default component.exports